import $ from "jquery";
import 'slick-carousel';

export const aboutGallerySlider = () => {
    $('.about-gallery-slider').slick({
        centerMode: true,
        centerPadding: '12px',
        slidesToShow: 1,
        variableWidth: true,
    });
};

